<template>
  <div class="service-role-list">
    <div class="module-item-style">
      <div class="service-role-add-btn-container" v-if="serviceRole == 0 || serviceRole == 1">
        <span class="wl-btn" @click="addRole">添加角色</span>
      </div>

      <div class="table-multi">
        <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            :header-cell-style="{background:'#f2f2f2'}"
            stripe
            style="border: 1px solid #ebeef5;"
            @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              :selectable="selectable"
              width="55">
          </el-table-column>
          <el-table-column
              v-for="(tHead, thIndex) in tableHead"
              v-if="!tHead.operate"
              :key="'th-' + thIndex"
              :width="tHead.width"
              :prop="tHead.value"
              :label="tHead.label">
          </el-table-column>
          <el-table-column v-else
                           :width="tHead.width"
                           :label="tHead.label">
            <template slot-scope="scope">
              <span v-if="scope.row.roleType == '系统' && (serviceRole == 0 || serviceRole == 1)">系统角色，无法进行操作</span>
              <div v-if="serviceRole == 0 || serviceRole == 1">
                <button class="tb-btn" v-if="scope.row.roleType != '系统'" :class="'tb-btn-'+handler.type" v-for="(handler, index) in tableHandler"
                        :key="'handler'+ index"
                        @click="handleOperate(handler.methods, scope.row)">{{handler.label}}</button>
              </div>
              <div v-else>
                无操作权限
              </div>

            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;padding-left: 14px;" v-if="tableData.length > 0 && (serviceRole == 0 || serviceRole == 1)">
          <el-checkbox  v-model="checkAll" @change="toggleSelection()"></el-checkbox>
          <span class="wl-btn-del" @click="handleOperate('delAll',SelectionData)">批量删除</span>
        </div>
        <pagenations
            :total="total"
            :size="pageSize"
            @pageHandler="pageOperate">
        </pagenations>
      </div>
    </div>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'
  export default {
    name: 'service-role-list',
    components: {
      pagenations
    },
    data() {
      return {
        tableHandler: [
          {label: "编辑", type: 'edit', methods: 'editMethods'},
          {label: "删除", type: 'del', methods: 'delMethods'},
        ],
        tableData: [],
        tableHead: [
          {
            label: '角色名称',
            value: 'roleName',
            type: 'image',
            operate: false
          }, {
            label: '角色类型',
            value: 'roleType',
            operate: false,
          }, {
            label: '操作',
            width:'170',
            value: 'title5',
            operate: true,
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        checkAll:'',
        SelectionData:[]
      }
    },


    created() {
      this.getRoleListFn()

    },
    computed:{
      serviceRole(){
        return this.$store.state.user.roles
      }
    },
    mounted() {

    },
    methods: {
      selectable(row,index){
        if(row.roleType == '系统'){
          return false
        }else {
          return true
        }
      },
      handleSelectionChange(val){
        if(val.length > 0){
          this.checkAll = true
        }else {
          this.checkAll = false
        }
        this.SelectionData = val
      },
      toggleSelection() {
        if (this.checkAll) {
          this.$refs.multipleTable.toggleAllSelection();
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val,data) {
        if (val == "delMethods") {
          let roleId = data.roleId
          if(this.total <= 1 + this.pageSize){
            this.currentPage = 1
          }
          this.$confirm('正在进行删除操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.delRoleSingle(roleId)
          }).catch(() => {

          });


        } else if (val == "delAll") {
          let roleIds = []
          data.map( item => {
            roleIds.push(item.roleId)
          })
          if(this.total <= data.length + this.pageSize){
            this.currentPage = 1
          }
        if(roleIds.length == 0){
          this.$message({
            message: '请选择要删除的数据',
            type: 'error'
          })
          return false
        }
          this.$confirm('正在进行删除操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.batchRole(roleIds)
          }).catch(() => {

          });


        }else if (val == "editMethods") {
          this.$router.push({
            name: 'serviceRoleSettingEdit',
            query:{
              roleId:data.roleId
            }
          })
        }
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getRoleListFn()
      },
      /**
       * 获取角色列表
       */
      getRoleListFn() {
        let postParams = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        this.$http.getRoleListAPI(postParams).then(res => {
          if (res.status == 1) {
            if(res.data.total <= res.data.pageSize){
              this.currentPage = 1
            }
            this.tableData = res.data.roleList
            this.pageSize = res.data.pageSize
            this.total = res.data.total

          }

        }).catch(err => {
          console.log(err)
        })
      },
      /**
       * 单个删除
       * */
      delRoleSingle(params){
        this.$http.delRoleSingleAPI({
          roleId:params
        }).then( res => {
          if (res.status == 1){
            this.getRoleListFn()
          }else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        }).catch( err => {

        })
      },
      /**
       *
       * 批量删除
       * */
      batchRole(params){
        this.$http.delRoleAllAPI({
          roleIds:params
        }).then( res => {
          if (res.status == 1){
            this.getRoleListFn()
          }else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }

        }).catch( err => {

        })
      },
      /**
       * 添加角色
       */
      addRole() {
        this.$router.push({
          name: 'serviceRoleSettingAdd'
        })
      }
    }
  }
</script>

<style lang="scss">
.service-role-list{

  .service-role-add-btn-container {
    display: flex;
    padding-bottom: 36px;

    .wl-btn {
      margin-left: auto;
    }
  }
}
</style>
